import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { takeUntil, tap } from 'rxjs';
import { TaskAssignee, TaskLabel } from '../taskbook.types';
import { TaskbookService } from '../taskbook.service';
import { TaskDialogService } from '../taskbook-dialog.service';

@Component({
    selector: 'task-assignee-and-label-popover',
    templateUrl: './task-assignee-and-label-popover.component.html',
    styleUrls: ['./task-assignee-and-label-popover.component.scss', './../taskbook-triage-actions/taskbook-triage-actions.component.scss', './../task/task.component.scss'],
    standalone: true,
    imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      TranslateModule
    ]
})
export class TaskAssigneeAndLabelPopoverComponent implements OnInit, OnChanges {

    protected availableAssignees: TaskAssignee[] = [];
    protected availableLabels: TaskLabel[] = [];
    protected searchCtrl = new FormControl<string>('');
    protected filteredLabels: TaskLabel[] = [];

    @Input() context: string;
    @Input() managers: TaskAssignee[];
    @Input() selectedAssignees: TaskAssignee[];
    @Input() selectedLabels: TaskLabel[];

    @Output() applyAssigneeAndLabelsSelection = new EventEmitter<{ labels: TaskLabel[], assignees: TaskAssignee[]}>();
  
    constructor(
      private taskbookService: TaskbookService,
      private taskDialogService: TaskDialogService,
      private cdr: ChangeDetectorRef,
    ) {}
  
    ngOnInit(): void {
      this.loadLabels();
    }
  
    ngOnChanges(): void {
    }

    setSelectedAssigneeClass(assignee: TaskAssignee): string {
      return this.selectedAssignees.filter(l => l.id === assignee.id).length > 0 ? 'selected' : '';
    }

    applyAssigneeAndLabels(selectedAssignees: TaskAssignee[], selectedLabels: TaskLabel[]): void {
      this.applyAssigneeAndLabelsSelection.emit({labels: selectedLabels, assignees: selectedAssignees});
    }

    // applyAssignees(selectedAssignees: TaskAssignee[]): void {
    //   this.applyAssigneeSelection.emit(selectedAssignees);
    //   this.selectedAssignees = [];
    // }
  
    toggleAssignee(assignee: TaskAssignee): void {
      if (this.selectedAssignees.filter(l => l.id === assignee.id).length > 0) {
        this.selectedAssignees = this.selectedAssignees.filter(l => l.id !== assignee.id);
      } else {
        this.selectedAssignees.push(assignee);
      }
    //   this.assigneesChange.emit(this.selectedAssignees);
    }

    loadLabels(){
      this.taskbookService.availableLabels().pipe(
        tap(availableLabels => {
            this.availableLabels = availableLabels;
            this.filteredLabels = availableLabels;
            this.cdr.detectChanges();
        }),
       ).subscribe();
    }

    setSelectedClass(label: TaskLabel): string {
      return this.selectedLabels.filter(l => l.id === label.id).length > 0 ? 'selected' : '';
    }

    // applyLabels(selectedLabels: TaskLabel[]): void {
    //   this.applyLabelSelection.emit(selectedLabels);
    //   this.selectedLabels = [];
    // }
  
    async addLabel() {
        const labelName = this.searchCtrl.getRawValue();
        if (this.availableLabels.map(label => label.name).indexOf(labelName) === -1) {
            //open dialog
            const newLabel = {
                name:  labelName,
                color: null,
                id: null
            };
            this.openLabelDialog(newLabel, 'create');
        }
    }

    async openLabelDialog(label: TaskLabel, mode) {
      const labelDialogRef = await this.taskDialogService.createOrEditTaskLabel(label, mode);
      labelDialogRef.beforeClosed().pipe(
          tap(label => {
            if (label && mode === 'create') {
              this.availableLabels.push(label);
              this.selectedLabels.push(label);
              this.cdr.detectChanges();
            }
            if (label && mode === 'edit') {
                this.taskbookService.editLabel(label).pipe(
                  tap(data => {
                      this.loadLabels();
                      this.cdr.detectChanges();
                  })
                ).subscribe();
            }
          }),
          takeUntil(labelDialogRef.afterClosed())
      ).subscribe();
    }

    editLabel(label: TaskLabel): void {
      this.openLabelDialog(label, 'edit');
    }

    deleteLabel(label: TaskLabel): void {
      this.taskbookService.deleteLabel(label).pipe(
        tap(data => {
            this.loadLabels();
        })
      ).subscribe();
    }
  
    toggleLabel(label: TaskLabel): void {
      if (this.selectedLabels.filter(l => l.id === label.id).length > 0) {
        this.selectedLabels = this.selectedLabels.filter(l => l.id !== label.id);
      } else {
        this.selectedLabels.push(label);
      }
    //   this.labelsChange.emit(this.selectedLabels);
    }
  }

